import initialState from './initial_state'
import * as types from '../actions/action_types'

export default function (state = initialState.reducerCampaigns, action) {

    // console.log("SSSS:", action)

    switch (action.type) {
        case types.ITEM_LIST_CAMPAIGNS_FULFILLED:
            return {
                itemListCampaigns: action.payload ? action.payload.data.results : [{}],
                isCampaignsLoaded: true
            }

        default:
            return state
    }
}
